module.exports = __webpack_public_path__ + "img/facebook-post.fbded889.png";